import React from 'react';

import {
  Modal, ModalHeader, ModalBody, Button, Input, FormGroup, Label
} from 'reactstrap';

import FormBuilder from './forms/formBuilder';
import { required, emailAddress, dateValidate, validateGender } from './forms/validation'
import { connect } from "react-redux";
import { formValueSelector, change } from "redux-form"; // ES6

import { API_ENDPOINT, GOOGLE_RECAPTCHA_SITE_KEY } from '../constants'

// import FaceID from "../faceApi/loginComponent";

import backIcon from '../assets/svg/back-icon.svg'

import Isvg from "react-inlinesvg";

import { Player, Controls } from "@lottiefiles/react-lottie-player";
// import BankIDModal_v2 from './bankIDModal_v2';
import BankIDModal_v5 from './bankIDModal_v5';
import BankIDModal_v6 from './bankIDModal_v6';
import { getSearchParams } from '../helpers/linkHelper';

import bankIdIcon from '../assets/images/bankid.png';
import mitIdIcon from '../assets/images/mitid.png';
import emailAndPasswordIcon from '../assets/images/email_ludo_a.png';
import arrowBackIcon from '../assets/svg/arrow-back.svg';
import TwoFactorAuthModal, { defaultError, isStringAValidNumber, isValidEmailAddress, isValidPassword } from './TwoFactorAuthModal';
import TwoFactorAuthV2LoginComponent from './auth/2fa-v2.login.component';
import phoneImage from '../assets/images/2fa_phone.png';
import emailImage from '../assets/images/2fa_email.png';

function parseJSON(response) {
  return response.json().then(json => {
    return {
      result: json,
      status: response.status
    }
  })
}
/**
* BankID modal for login
* @author   Milan Stanojevic
*/
class BankIdModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      navigateToMyChildren: false,
      lastLoggedUser: null,
      // faceId: null,
      openFirstPatientLoginModal: true,
      loading: true,

      showBankId: false,
      showEmailPw: false,
      createProfile: false,

      email: '',
      password: '',

      code: '',

      loginError: null,
      codeSent: false,
      uid: null,
      phone: null,
      showCodeMessage: false,
      loginGroupAlias: null,

      hideOtherAuthOptions: false,
      specialImage: null,
      mode: null,
    }
    this.componentUnmounted = false;
    this.loginToggleCalled = false;
  }

  setHideOtherAuthOptions = (value, img = null) => {
    this.setState({ hideOtherAuthOptions: (value ?? false), specialImage: img });
  }

  componentDidMount() {
    // if (typeof window != 'undefined') {
    //   localStorage?.setItem('openFirstPatientLoginModal', this.state.openFirstPatientLoginModal)
    // }
    let params = getSearchParams(this.props[0].location.search);
    if (params && params.navigateToMyChildren) this.setState({ navigateToMyChildren: true })
    if ((params && params.qrCodeLink) /*|| (typeof window !== 'undefined' && localStorage.bankIdStarted)*/) {
      this.setState({
        showBankId: true
      })

    }

    if (localStorage.getItem('groupAlias')) {
      this.setState({ loginGroupAlias: localStorage.getItem('groupAlias') })
    }
    window.addEventListener('message', (e) => {
      return;

      if (this.componentUnmounted) {
        return;
      }
      if (e.data == 'loggedin') {

        localStorage?.setItem('loginLandingPage', true);
        localStorage?.setItem('logoutLandingPage', true);
        if (localStorage?.getItem('groupAlias'))
          localStorage?.setItem('loginGroupAlias', localStorage?.getItem('groupAlias'));
        let setVerifyRedirectLink;
        if (this.props.setVerifyRedirectLink) {
          setVerifyRedirectLink = this.props.setVerifyRedirectLink
        }

        this.props.verifyUser((uData) => {
          if (this.props.openLastLoginLanding && this.props.clinicGroupsItems && this.props.clinicGroupsItems.length) {
            if (uData && uData.lastVisitedGroups && uData.lastVisitedGroups.length) {
              let lastVisitedGroups = uData.lastVisitedGroups.reverse();
              for (let i = 0; i < lastVisitedGroups.length; i++) {
                if (this.props.clinicGroupsItems.filter(el => el.alias == lastVisitedGroups[i].alias).length) {
                  alias = lastVisitedGroups[i].alias;
                  break;
                }
              }
              let alias;
              if (alias) {
                this.props.toggle(alias);
              } else {
                this.props.toggle();
              }
            } else {
              this.props.toggle();
            }
          } else {
            this.props.toggle();
          }

        }, null, false, setVerifyRedirectLink);

      } else if (e.data == 'loggedin_newuser') {
        if (this.props.videoCallGateway) {
          this.props.toggle()
          return
        }
        localStorage?.setItem('loginLandingPage', true);
        localStorage?.setItem('logoutLandingPage', true);
        if (localStorage?.getItem('groupAlias'))
          localStorage?.setItem('loginGroupAlias', localStorage?.getItem('groupAlias'));

        let setVerifyRedirectLink;
        if (this.props.setVerifyRedirectLink) {
          setVerifyRedirectLink = this.props.setVerifyRedirectLink
        }

        this.props.verifyUser(() => {
          if (this.props.toggle)
            this.props.toggle();
        }, null, true, setVerifyRedirectLink);
        this.setState({
          loggedIn: true
        })

      }
    }, false)




    if (this.props.uData) {
      this.setState({
        loggedIn: true
      })
    }

    this.getGroupId()


  }

  callMitIDRedirect = () => {
    fetch(API_ENDPOINT + `/users/mitID/web/start`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify({ group: groupObj._id, alias: this.props?.[0]?.match?.params?.alias, redirectLink: window.location.href })
    }).then(res => res.json()).then((result) => {
      // console.log(result);

      if (result.redirect_url) {
        this.setState({
          showMitId: result.redirect_url,
          mitIdKey: result.key
        })
      }
    })
  }

  update = (data) => {

    fetch(API_ENDPOINT + '/users/account/update', {
      method: 'POST',
      headers: {
        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage?.getItem('authToken')}` : null,
        'content-type': 'application/json'
      },
      body: JSON.stringify(data)
    }).then(parseJSON).then(({ result, status }) => {
      if (result.error) {
        this.setState({ error: result.error.translate(this.props.lang) })
      } else {
        this.setState({
          message: result.message,
          openFirstPatientLoginModal: false
        })
        this.props.verifyUser();
        this.props.toggle();
      }

    })


  }
  componentDidUpdate(prevProps, prevState) {

    if (prevProps.sex != this.props.sex) {
      if (this.props.sex == 0) {
        this.props.changeSex(null)
      }
    }

    if (prevProps.socialSecurityNumber !== this.props.socialSecurityNumber) {
      if ((this.props.country === 'denmark' && this.props.socialSecurityNumber?.length === 10) || this.props.socialSecurityNumber?.length === 12) {
        let dateOfBirth = this.props.getDateOfBirthFromSSN(this.props.socialSecurityNumber);
        if (dateOfBirth && this.props.changeDateOfBirth) {
          this.props.changeDateOfBirth(dateOfBirth)
          if (!this.state.disabledDateOfBirth) { this.setState({ disabledDateOfBirth: true }) }
        } else {
          if (this.state.disabledDateOfBirth) { this.setState({ disabledDateOfBirth: false }) }
        }
      } else {
        if (this.state.disabledDateOfBirth) { this.setState({ disabledDateOfBirth: false }) }
      }
    }

    if (this.state.loginError) {
      if (this.state.codeSent && prevState?.code !== this.state?.code) this.setState({ loginError: null });
      if (!this.state.codeSent && (prevState?.email !== this.state?.email) || (prevState?.password !== this.state?.password)) this.setState({ loginError: null })
    }

  }

  componentWillUnmount() {
    this.componentUnmounted = true;

  }

  getGroupId = () => {
    let groupAlias;
    let groupId;
    if (typeof window != 'undefined' && localStorage?.groupAlias) {
      groupAlias = localStorage?.groupAlias;
    }
    if (this.props[0].match.params.alias) {
      groupAlias = this.props[0].match.params.alias;
    } else if (typeof window != 'undefined' && localStorage?.groupAlias) {
      groupAlias = localStorage?.groupAlias;
    }
    if (this.props.videoCallGroup) {
      groupId = this.props.videoCallGroup;
    }

    if (groupAlias || groupId) {
      let obj = {}

      if (groupAlias && !groupId) obj.alias = groupAlias;
      if (groupId) obj.id = groupId;

      fetch(API_ENDPOINT + "/data/clinic-group/info", {
        method: "POST",
        headers: {
          Authorization:
            typeof localStorage !== "undefined"
              ? `Bearer ${localStorage?.getItem("authToken")}`
              : null,
          "content-type": "application/json",
        },
        body: JSON.stringify(obj),
      }).then(parseJSON).then(({ result, status }) => {
        if (result && result._id) {
          this.setState({ groupObj: result }, () => {
            let mitIdDataAfterRedirect = {}

            // if there is more state then just link add them in mitIDPage.js
            if (this.props.webBooking) {
              mitIdDataAfterRedirect.redirectLink = window.location.pathname
              mitIdDataAfterRedirect.calendarModal = true
              mitIdDataAfterRedirect.clinicGroup = this.state.groupObj
              mitIdDataAfterRedirect.selectedReferral = this.props.selectedReferral
              mitIdDataAfterRedirect.referral = this.props.personalQuestionary
              mitIdDataAfterRedirect.selectedEvent = this.props.selectedEvent
              mitIdDataAfterRedirect.doctor = this.props.doctor
            } else if (this.props.dropIn) {
              mitIdDataAfterRedirect.redirectLink = this.props[0].match.params.mainAlias ? `/${this.props[0].match.params.mainAlias}/${this.props[0].match.params.alias}/drop-in` : `/${this.props[0].match.params.alias}/drop-in`
              mitIdDataAfterRedirect.isDropIn = true
              mitIdDataAfterRedirect.selectedDropInForm = this.props.selectedDropInForm
            } else if (this.props.myReferrals) {
              mitIdDataAfterRedirect.redirectLink = `/my-data/personal-referrals/referrals`
            } else if (this.props.seekCare) {
              mitIdDataAfterRedirect.redirectLink = this.props[0].match.params.mainAlias ? `/${this.props[0].match.params.mainAlias}/${this.props[0].match.params.alias}/personal-referral` : `/${this.props[0].match.params.alias}/personal-referral`
            } else if (this.props.dayBook) {
              mitIdDataAfterRedirect.redirectLink = '/my-data/account'
              mitIdDataAfterRedirect.tabIndex = 2
            } else if (this.props.waitingRoom) {
              mitIdDataAfterRedirect.redirectLink = '/waiting-room'
            } else {
              mitIdDataAfterRedirect.redirectLink = `/${this.props[0].match.params.alias}`
            }
            fetch(API_ENDPOINT + `/users/mitID/web/start`, {
              method: 'POST',
              headers: {
                'content-type': 'application/json'
              },
              body: JSON.stringify({ group: this.state.groupObj._id, alias: this.props?.[0]?.match?.params?.alias, mitIdDataAfterRedirect: JSON.stringify(mitIdDataAfterRedirect) })
            }).then(res => res.json()).then((result) => {

              if (result.redirect_url) {
                this.setState({
                  showMitId: result.redirect_url,
                  mitIdKey: result.key
                })
              }
            })

            this.setState({ loading: false })
          })
        } else this.setState({ loading: false })
      }).catch(err => {
        this.setState({ loading: false })
      })
    } else this.setState({ loading: false })

  }

  getRecaptchaToken = (action) => new Promise(async (res) => {
    try {
      if (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') return res('test');
      if (typeof grecaptcha === 'undefined') return res(null);
      const token = await grecaptcha.execute(GOOGLE_RECAPTCHA_SITE_KEY, { action: action.replace(/-/g, '') });

      if (token) return res(token);
      else return res(null);
    } catch (err) {
      console.log('getRecaptchaToken err: ', err);
      return res(null);
    }
  })

  login = (action, result) => {
    if (!this.state?.groupObj?.twoFactorAuthentication) return;

    if (action === '2fa-v2-login' && result) {
      try {
        if (result?.userData && typeof window !== 'undefined') {
          localStorage?.setItem?.('userData', JSON.stringify(result?.userData));
        }
      } catch (err) {
        console.error('login user data err: ', err);
      }

      if (window?.top) window.top.postMessage('loggedin', '*');

      localStorage?.setItem('authToken', result.token);
      localStorage?.setItem('time', Math.floor(Date.now() / 1000))
      localStorage?.setItem('profile', 'patient');
      localStorage?.setItem('2faLogin', 'true');

      if (localStorage?.getItem('groupAlias')) {
        localStorage?.setItem('logoutLandingPage', true);
        localStorage?.setItem('loginGroupAlias', localStorage?.getItem('groupAlias'));
      } else if (this.props.alias) {
        localStorage?.setItem('groupAlias', this.props.alias)
        localStorage?.setItem('logoutLandingPage', true);
        localStorage?.setItem('loginGroupAlias', this.props.alias);
      }

      this.props?.verifyUser?.(() => {
        if (this.state.navigateToMyChildren && (this.props?.uData?.userLevel == 2 || (this.props?.uData?.userLevel == 20 && typeof window !== 'undefined' && localStorage?.getItem?.('profile') == 'patient'))) {
          // Nothing
        } else {
          this.props?.toggle?.();
        };

      }, null, null, () => {
        if (this.state.navigateToMyChildren && (this.props?.uData?.userLevel == 2 || (this.props?.uData?.userLevel == 20 && typeof window !== 'undefined' && localStorage?.getItem?.('profile') == 'patient'))) {
          this.props?.[0]?.history?.push?.(
            '/my-data/account',
            { navigateToMyChildren: true }
          );
        } else {
          this.props?.toggle?.();
        };
      });
    }

    return;

    if (action === 'email-pw') {
      if (!this.state.email?.trim?.() || !isValidEmailAddress(this.state.email)) return this.setState({ loginError: 'Invalid email address!' });
      if (!this.state.password?.trim?.() || !isValidPassword(this.state.password)) return this.setState({ loginError: 'Minimum 10 characters, at least one uppercase letter, one lowercase letter, one number and one special character:' });

      this.setState({ loading: true, loginError: null }, async () => {

        let newState = {
          loading: false,
        }

        const _token = await this.getRecaptchaToken('login');
        if (!_token) {
          newState.loginError = defaultError;
          return this.setState(newState);
        }

        const response = await fetch(API_ENDPOINT + '/users/two-factor-auth/login', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: this.state.email,
            password: this.state.password,
            groupId: this.state.groupObj?._id,
            lang: this.props.lang,
            action: 'login',
            _token,
          })
        });

        if (!response) {
          newState.codeSent = false;
          newState.loginError = defaultError;
          return this.setState(newState);
        }

        const result = await response.json();

        if (result.errors && Array.isArray(result.errors) && result.errors.length > 0) {
          const err = result.errors.map(e => e.translate(this.props.lang)).join(' ');
          newState.codeSent = false;
          newState.loginError = err;
          return this.setState(newState);
        }

        if (!result || result.error || !result.codeSent || !result.uid) {
          newState.codeSent = false;
          newState.loginError = result?.error || defaultError;
          return this.setState(newState);
        }

        newState.codeSent = true;
        newState.uid = result.uid;
        newState.phone = result?.phone;
        newState.showCodeMessage = true;
        newState.useOnlyEmailFor2fa = result?.useOnlyEmailFor2fa || false;
        newState.userEmail = result?.email || '';
        this.setState(newState);
      });
    }

    else if (action === 'code') {
      if (!this.state.uid) return this.setState({ loginError: defaultError });
      if (!this.state.code?.trim?.() || !isStringAValidNumber(this.state.code) || !this.state.code?.trim?.()?.length) return this.setState({ loginError: 'Please enter a valid 6 digit code!' });

      this.setState({ loading: true, loginError: null }, async () => {
        let newState = {
          loading: false,
        }

        const _token = await this.getRecaptchaToken('logincode');
        if (!_token) {
          newState.loginError = defaultError;
          return this.setState(newState);
        }

        const response = await fetch(API_ENDPOINT + '/users/two-factor-auth/check-code', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            code: this.state.code,
            uid: this.state.uid,
            groupId: this.state.groupObj?._id,
            action: 'logincode',
            _token,
          })
        });

        if (!response) {
          newState.loginError = defaultError;
          return this.setState(newState);
        }

        const result = await response.json();

        if (!result || !result.token || result.error) {
          newState.loginError = result?.error || defaultError;
          return this.setState(newState);
        }

        try {
          if (result?.userData && typeof window !== 'undefined') {
            localStorage?.setItem?.('userData', JSON.stringify(result?.userData));
          }
        } catch (err) {
          console.error('login user data err: ', err);
        }

        if (window?.top) window.top.postMessage('loggedin', '*');

        localStorage?.setItem('authToken', result.token);
        localStorage?.setItem('time', Math.floor(Date.now() / 1000))
        localStorage?.setItem('profile', 'patient');
        localStorage?.setItem('2faLogin', 'true');

        if (localStorage?.getItem('groupAlias')) {
          localStorage?.setItem('logoutLandingPage', true);
          localStorage?.setItem('loginGroupAlias', localStorage?.getItem('groupAlias'));
        } else if (this.props.alias) {
          localStorage?.setItem('groupAlias', this.props.alias)
          localStorage?.setItem('logoutLandingPage', true);
          localStorage?.setItem('loginGroupAlias', this.props.alias);
        }

        this.props?.verifyUser?.(() => {
          if (this.state.navigateToMyChildren && (this.props?.uData?.userLevel == 2 || (this.props?.uData?.userLevel == 20 && typeof window !== 'undefined' && localStorage?.getItem?.('profile') == 'patient'))) {
            // Nothing
          } else {
            this.props?.toggle?.();
          };

        }, null, null, () => {
          if (this.state.navigateToMyChildren && (this.props?.uData?.userLevel == 2 || (this.props?.uData?.userLevel == 20 && typeof window !== 'undefined' && localStorage?.getItem?.('profile') == 'patient'))) {
            this.props?.[0]?.history?.push?.(
              '/my-data/account',
              { navigateToMyChildren: true }
            );
          } else {
            this.props?.toggle?.();
          };
        });
      });
    }

    else if (action === 'resend') {
      this.setState({ loading: true, loginError: null }, async () => {
        let newState = {
          loading: false,
        };

        const _token = await this.getRecaptchaToken('loginresendcode');
        if (!_token) {
          newState.loginError = defaultError;
          return this.setState(newState);
        }

        const response = await fetch(API_ENDPOINT + '/users/two-factor-auth/resend-code', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            uid: this.state.uid,
            groupId: this.state.groupObj?._id,
            action: 'loginresendcode',
            _token,
          })
        });

        if (!response || !response.ok) {
          let err = defaultError;
          if (response.status === 429) err = 'You have sent too many requests for resending the verification code!';
          newState.loginError = err;
          return this.setState(newState);
        };

        return this.setState(newState);
      });
    }

    else return;
    // console.log('props 0: ', this.props?.[0]);
  }

  updateMode = () => {
    const el = document.getElementById('above-qr-image-p')
    if (!el) return;
    let edgeOffset = 5
    const rect = el.getBoundingClientRect();

    const loginModal = document.getElementById('login-modal-position')
    if (loginModal) {
      edgeOffset = loginModal.getBoundingClientRect()?.top
      const qrEl = document.getElementById('qr-image-div')
      if (this.state.mode === 'top' && qrEl) {
        edgeOffset += qrEl.offsetHeight
      }
    }
    // console.log(rect.top, ' ', loginModal.getBoundingClientRect()?.top, ' ', edgeOffset, ' ', this.state.mode);

    // If the element's top touches or goes above viewport top -> stick top
    if (rect.top <= edgeOffset) {
      this.setState({ mode: "top" });

      return;
    }

    // If the element's bottom touches or goes below viewport bottom -> stick bottom
    if (rect.bottom > window.innerHeight) {
      this.setState({ mode: "bottom" });
      return;
    }

    // Otherwise normal flow
    this.setState({ mode: "normal" });
  };
  render() {
    const { groupObj, hideOtherAuthOptions, specialImage } = this.state;
    let showPrivacyPolicyCheckbox = false;
    if (this.state.groupObj && this.state.groupObj._id && this.props.uData && (this.props.uData.userLevel === 1 || this.props.uData.userLevel === 2 || (this.props.uData.userLevel === 20 && typeof window != 'undefined' && localStorage?.getItem?.('profile') === 'patient'))) {
      showPrivacyPolicyCheckbox = true
    }
    let label2;

    if (showPrivacyPolicyCheckbox) {
      let privacyPolicy = groupObj.privacyPolicy && groupObj.privacyPolicy.file ? `${API_ENDPOINT}${groupObj.privacyPolicy.file}` : null;

      label2 =
        <div className='privacy-policy-field-label-wrap' style={{ marginTop: 20 }}>
          <p style={{ fontSize: 14 }}> {'You can read about how we handle your personal data:'.translate(this.props.lang)} {privacyPolicy ? <a href={privacyPolicy} target="_blank">{'Privacy Policy'.translate(this.props.lang)}</a> : 'Privacy Policy'.translate(this.props.lang)}.</p>
        </div>
    }

    if (this.state.loading) return <Modal isOpen={this.state.loading} centered style={{ position: 'relative' }}>
      <ModalHeader toggle={!this.props.uData ? this.props.toggle : null} close={!this.props.uData ? <button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={this.props.uData ? null : this.props.toggle}>&times;</button> : null}>
        {groupObj?.logo ? <img key='logo' src={API_ENDPOINT + groupObj?.logo} className="login-clinic-logo" /> : null}
        {
          // this.state.faceId ?
          //   'Login with face'.translate(this.props.lang)
          //   :
          this.props.checkLastLogin ?
            'Log in'.translate(this.props.lang)
            :
            'Login with BankId'.translate(this.props.lang)
        }
      </ModalHeader>
      <ModalBody>
        <Player
          autoplay={true}
          loop={true}
          src="/lf30_editor_l5cxzdyf.json"
          style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px" }}
        />
      </ModalBody>
    </Modal>;

    if (this.state.createProfile && !this.props.hideCreateAccountButton && false) return <TwoFactorAuthModal
      secondaryLanguageDisabled={this.props.secondaryLanguageDisabled}
      countryTwoLetter={this.props.countryTwoLetter}
      country={this.props.country}
      type='create-account'
      closeModal={() => this.setState({ createProfile: false })}
      navigate={() => {
        this.setState({ navigateToMyChildren: true }, () => {
          console.log('navigate: ', this.state.navigateToMyChildren)
        })
      }}
      lang={this.props.lang}
      show2FAModal={this.state.createProfile}
      alias={this.props?.[0]?.match?.params?.alias}
      clinicsAgeLimitExceptions={this.props.clinicsAgeLimitExceptions}
    />


    return (
      <Modal scrollable id="login-modal-position" isOpen={this.props.isOpen} centered backdrop='static' size={this.props.sideComponent ? 'lg' : 'md'}>
        <ModalHeader className='login-modal-header' style={{ textAlign: 'center' }} toggle={!this.props.uData ? this.props.toggle : null} close={!this.props.uData ? <button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={this.props.uData ? null : this.props.toggle}>&times;</button> : null}>
          {specialImage && ['email', 'phone'].includes(specialImage) && !this.props.sideComponent ? <img key={specialImage} src={specialImage === 'phone' ? phoneImage : emailImage} className="login-clinic-logo" /> : groupObj?.logo ? <img src={API_ENDPOINT + groupObj?.logo} /> : null}
          {this.props.sideComponent ? null : <p> {
            // this.state.faceId ?
            //   'Login with face'.translate(this.props.lang)
            //   :
            this.props.checkLastLogin ?
              'Log in'.translate(this.props.lang)
              :
              'Login with BankId'.translate(this.props.lang)
          }</p>}
        </ModalHeader>
        <ModalBody
          // onScroll={() => this.updateMode()} 
          className={`bankid-modal ${this.props.sideComponent ? 'bankidmodal-with-side-component' : ''}`}>
          <div style={{ width: '100%' }}>
            {this.props.sideComponent ? <p className='login-modal-with-side-component-title'>
              {'Login to continue'.translate(this.props.lang)}
            </p> : null}
            {

              // this.state.faceId ?
              //   <div style={{ display: 'flex', flexDirection: 'column' }}>
              //     <div className='bankid-modal-faceid-wrap'>
              //       <FaceID {...this.props}
              //         checkPhoto={(photo) => {
              //           this.setState({ scannedPhoto: photo }, () => {
              //             if (!this.state.loadingFaceId) {
              //               this.checkPhoto(this.state.scannedPhoto);
              //             }
              //           })
              //         }}

              //       />
              //       {
              //         !this.state.noMatchError && !this.state.succesScanning ?
              //           <div className='no-match-error-wrap'>
              //             <div className='scan-loading'>
              //               <Player
              //                 autoplay={true}
              //                 loop={true}
              //                 src="/lf30_editor_l5cxzdyf.json"
              //                 style={{ height: "128px", width: "128px" }}
              //               ></Player>
              //             </div>
              //           </div>
              //           :
              //           null
              //       }
              //       {
              //         this.state.succesScanning ?
              //           <div className='no-match-error-wrap'>
              //             <div className='scan-loading-success'>
              //               <Player
              //                 autoplay={true}
              //                 loop={false}
              //                 src="https://assets4.lottiefiles.com/packages/lf20_oaw8d1yt.json"
              //                 style={{ height: "128px", width: "128px" }}
              //                 keepLastFrame={true}
              //               ></Player>

              //             </div>
              //           </div>
              //           :
              //           null
              //       }
              //       {
              //         this.state.noMatchError ?
              //           <div className='no-match-error-wrap'>
              //             <div className='no-match-error'>
              //               <p>{'No match, try again'.translate(this.props.lang)}</p>
              //             </div>
              //           </div>
              //           :
              //           null
              //       }

              //     </div>
              //     <div style={{ padding: '0px 18px', display: 'flex', width: '100%' }}>
              //       <Button color='primary' className='close-faceid-btn' onClick={() => this.setState({ faceId: false })}><Isvg src={backIcon} />{'Login with BankId'.translate(this.props.lang)}</Button>
              //     </div>
              //   </div>
              //   :

              //   this.state.lastLoggedUsers && this.state.lastLoggedUsers.length && !this.state.faceId ?
              //     <div style={{ padding: '0 15px' }}>
              //       <h6>{'Continue as'.translate(this.props.lang)}:</h6>
              //       <div className="face-id-user-wrap-container" style={{ justifyContent: typeof window != 'undefined' && window.innerWidth < 768 ? this.state.lastLoggedUsers.length < 3 ? 'center' : 'unset' : this.state.lastLoggedUsers.length < 4 ? 'center' : 'unset' }}>

              //         {
              //           this.state.lastLoggedUsers.map((item, idx) => {
              //             return (
              //               <div className="face-id-user-wrap" onClick={() => {
              //                 this.setState({ faceId: item._id })
              //               }}>
              //                 <div className="user-image" >
              //                   {
              //                     item.profilePicture ?
              //                       <img src={API_ENDPOINT + item.profilePicture} />
              //                       :
              //                       <img src={'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF4AAABeCAYAAACq0qNuAAAABHNCSVQICAgIfAhkiAAABXdJREFUeF7tm09s1EUUxx8gm227rW23CNuWrsJuSGQ3EROoF8rBJmBP7UUMiRd6hKMe9cDFRDx4gJtea/QCXhpIuFgP1pqAyWLUbBUX264Wd4vttjRbieY76Rrb/f3/7e/3Ztc3SROSnZk383nf35uZN8Oe19+f/ZukhE5gj4APnbkyKOB5uAt4Ju4CXsBzEWCyKzFewDMRYDIrihfwTASYzIriBTwTASazongBz0SAyawoXsAzEWAyK4oX8EwEmMyK4gU8EwEms6J4Ac9EgMmsKF7A2xNoi+yj7FAnZZPPUk9nhAbjUdWovFalUqVKucIa3S+sUrlSte+MuUZTKB7AzxyP00imj9oj+2yRfZ1fodt3l7V2gPbge2MRujia/FfdttS3K2xUn9InXyxQ7uGq0yah1tMa/EA8SpfGjjhSuRm1qZkFmsuvhArViTFtwSO8vD2eot7OiJN5WNa5ejNPi6VN3/00sgNtwV8YOUyn0t2Wc50vrqvf8WXAUWYFi++Vz35sJDfffWkJPpWI0eWxFwwn96T6lG7MFilXWCX8u1bQZmI4oZxgVG7dW6Zbd3/3DaxRHWgJ3kztAH1t+mfTsAHVT44mKZXoqOOjm+q1BP/emy8aho5r0w9ovlixFB3gv3v+mGF7nWK9duDNwgwWR4BzUs69fJDOnXiurqpO4aZpwLuBZuY8N304cbCfOi0JHocuhJvdZS7/mKZmfvXDq2FtWxK8KN6DPsygLZQ26QOJ8R6Iumjid1fzzvljhmkG2dXYOMFsH4/E13WbffzF0SFKJ2L1+/jKFl359AcX7g+2qnYxHtO1OrkC/s2vlmhu/vEOMmgzPpwwzWLqtKPBwLUEj4E5ydXktw9TA/E2ywxmubJFV2/kd6QYgtWzfe/aglfZyYk09cb228/CpoZOsb02VG3BY4BIeF0eO2KZebTziuTj7QiZ/A74F04fNs06mnWLhNqU3EB5pL7dTN25ZvrUvatV3r1mBSdUpIB1vvTWOtTsdpd6ZZDsUn9IC9Ry71g8kfZFjh5/OgNvihjv7zvRu3VTKV5vlO5GpxV4XGz390YpfahDhREcitQbmXvLKpS4Ke2RZ2gkE6e2/Xsp/9u6euikU2EHD9jZoS46me6xfDuDJNnMd3/QUnmTFkpPDBmir9ShDtXf0f6OukMVbq+w8N4vrNFG9S9WP7CBT/fH6OxLB5SqvRR8Af9dRN32k/tllWa+L1F+yfoq0cvYnLQJHfypdI+6lmvEexknE7Srg6/g9rePQndAaOAH4230xulB10/x7MA16nc4YOrLRddriVf7gYPHInf2xAF1ANK9IPP5+WxRLehBl8DBT76apOzzXY7mgWM+DkA/FdfVk+uBviidTHUTwpOXgp0MFmK1gCe7HJ16YefjOw8pV/jTi0nHbQIFj/Dy1njKdjB4VArQVpPFYnz0YDuhz2hkb92ijIUWC+5ieZPmixvKebt3LnhXP5zupkzSWghw2Ed3Crbj9lMhUPCAdek146d4GDTyKbjQcLtH9zNhtMUXgAXe7EtCvMfjqSALC/iwFzIzgGZfZMuCh9JxFadD+XAyWzcMAR+CZwR8CJCNTPyvwGOf/E1+5ysBJu6G7/BbNtRwQXZqV8A7JdXgegK+wUCddtf04J2eXJ0CCateGNvdQA9QADXxSoLOHNc/QVZzKv7nyfXpB4FflAQOHhOC8jNDnWEJ1rOdlcqWyhmFcTsVCnjPJFq4oYBncq6AF/BMBJjMiuIFPBMBJrOieAHPRIDJrChewDMRYDIrihfwTASYzIriBTwTASazongBz0SAyawoXsAzEWAyK4oX8EwEmMyK4gU8EwEms6J4Ac9EgMmsKF7AMxFgMvsP3FL9zxFbsSwAAAAASUVORK5CYII='} />
              //                   }

              //                 </div>
              //                 <h6>{item.name}</h6>
              //               </div>

              //             )
              //           })
              //         }
              //       </div>
              //       <div className="login-divider">
              //         <hr /> <span>{"or".translate(this.props.lang)}</span>{" "}
              //         <hr />
              //       </div>
              //     </div>

              //     :
              //     null

              // this.state.lastLoggedUser && !this.state.faceId ?
              //   <div style={{ padding: '0 15px' }}>
              //     <h6>{'Continue as'.translate(this.props.lang)}:</h6>

              //     <div className="face-id-user-wrap-container">
              //       <div className="face-id-user-wrap" onClick={() => {
              //         this.setState({ faceId: true })
              //       }}>
              //         <div className="user-image" >
              //           {
              //             this.state.lastLoggedUser.profilePicture ?
              //               <img src={API_ENDPOINT + this.state.lastLoggedUser.profilePicture} />
              //               :
              //               <img src={'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF4AAABeCAYAAACq0qNuAAAABHNCSVQICAgIfAhkiAAABXdJREFUeF7tm09s1EUUxx8gm227rW23CNuWrsJuSGQ3EROoF8rBJmBP7UUMiRd6hKMe9cDFRDx4gJtea/QCXhpIuFgP1pqAyWLUbBUX264Wd4vttjRbieY76Rrb/f3/7e/3Ztc3SROSnZk383nf35uZN8Oe19+f/ZukhE5gj4APnbkyKOB5uAt4Ju4CXsBzEWCyKzFewDMRYDIrihfwTASYzIriBTwTASazongBz0SAyawoXsAzEWAyK4oX8EwEmMyK4gU8EwEms6J4Ac9EgMmsKF7A2xNoi+yj7FAnZZPPUk9nhAbjUdWovFalUqVKucIa3S+sUrlSte+MuUZTKB7AzxyP00imj9oj+2yRfZ1fodt3l7V2gPbge2MRujia/FfdttS3K2xUn9InXyxQ7uGq0yah1tMa/EA8SpfGjjhSuRm1qZkFmsuvhArViTFtwSO8vD2eot7OiJN5WNa5ejNPi6VN3/00sgNtwV8YOUyn0t2Wc50vrqvf8WXAUWYFi++Vz35sJDfffWkJPpWI0eWxFwwn96T6lG7MFilXWCX8u1bQZmI4oZxgVG7dW6Zbd3/3DaxRHWgJ3kztAH1t+mfTsAHVT44mKZXoqOOjm+q1BP/emy8aho5r0w9ovlixFB3gv3v+mGF7nWK9duDNwgwWR4BzUs69fJDOnXiurqpO4aZpwLuBZuY8N304cbCfOi0JHocuhJvdZS7/mKZmfvXDq2FtWxK8KN6DPsygLZQ26QOJ8R6Iumjid1fzzvljhmkG2dXYOMFsH4/E13WbffzF0SFKJ2L1+/jKFl359AcX7g+2qnYxHtO1OrkC/s2vlmhu/vEOMmgzPpwwzWLqtKPBwLUEj4E5ydXktw9TA/E2ywxmubJFV2/kd6QYgtWzfe/aglfZyYk09cb228/CpoZOsb02VG3BY4BIeF0eO2KZebTziuTj7QiZ/A74F04fNs06mnWLhNqU3EB5pL7dTN25ZvrUvatV3r1mBSdUpIB1vvTWOtTsdpd6ZZDsUn9IC9Ry71g8kfZFjh5/OgNvihjv7zvRu3VTKV5vlO5GpxV4XGz390YpfahDhREcitQbmXvLKpS4Ke2RZ2gkE6e2/Xsp/9u6euikU2EHD9jZoS46me6xfDuDJNnMd3/QUnmTFkpPDBmir9ShDtXf0f6OukMVbq+w8N4vrNFG9S9WP7CBT/fH6OxLB5SqvRR8Af9dRN32k/tllWa+L1F+yfoq0cvYnLQJHfypdI+6lmvEexknE7Srg6/g9rePQndAaOAH4230xulB10/x7MA16nc4YOrLRddriVf7gYPHInf2xAF1ANK9IPP5+WxRLehBl8DBT76apOzzXY7mgWM+DkA/FdfVk+uBviidTHUTwpOXgp0MFmK1gCe7HJ16YefjOw8pV/jTi0nHbQIFj/Dy1njKdjB4VArQVpPFYnz0YDuhz2hkb92ijIUWC+5ieZPmixvKebt3LnhXP5zupkzSWghw2Ed3Crbj9lMhUPCAdek146d4GDTyKbjQcLtH9zNhtMUXgAXe7EtCvMfjqSALC/iwFzIzgGZfZMuCh9JxFadD+XAyWzcMAR+CZwR8CJCNTPyvwGOf/E1+5ysBJu6G7/BbNtRwQXZqV8A7JdXgegK+wUCddtf04J2eXJ0CCateGNvdQA9QADXxSoLOHNc/QVZzKv7nyfXpB4FflAQOHhOC8jNDnWEJ1rOdlcqWyhmFcTsVCnjPJFq4oYBncq6AF/BMBJjMiuIFPBMBJrOieAHPRIDJrChewDMRYDIrihfwTASYzIriBTwTASazongBz0SAyawoXsAzEWAyK4oX8EwEmMyK4gU8EwEms6J4Ac9EgMmsKF7AMxFgMvsP3FL9zxFbsSwAAAAASUVORK5CYII='} />
              //           }

              //         </div>
              //         <h6>{this.state.lastLoggedUser.name}</h6>
              //       </div>

              //     </div>

              //     <div className="login-divider">
              //       <hr /> <span>{"or".translate(this.props.lang)}</span>{" "}
              //       <hr />
              //     </div>

              //   </div>
              //   :
              //   null
            }
            {
              !this.state.loggedIn && !this.state.faceId
                ?
                (groupObj?.twoFactorAuthentication || groupObj?.bankIdAuthentication || groupObj?.mitIdAuthentication)
                  ? <div className='patient-modal-2fa'>
                    {
                      ((groupObj?.twoFactorAuthentication && groupObj?.bankIdAuthentication) || (groupObj?.twoFactorAuthentication && groupObj?.mitIdAuthentication) || (groupObj?.bankIdAuthentication && groupObj?.mitIdAuthentication)) && (this.state.showBankId) || this.state.showEmailPw
                        ? <div className='go-back-div'>
                          <button
                            onClick={() => this.setState({
                              showBankId: false,
                              showEmailPw: false,
                              // showMitId: false,
                              createProfile: false,
                              email: '',
                              password: '',
                              code: '',
                              loginError: null,
                              codeSent: false,
                              uid: null,
                              phone: null
                            }, () => {
                              // if (typeof window !== 'undefined') {
                              //   localStorage.removeItem('bankIdStarted')
                              // }
                            })}
                          >
                            <Isvg src={arrowBackIcon} />
                            <span>
                              {'go back'.translate(this.props.lang)}
                            </span>
                          </button>
                        </div>
                        : null
                    }

                    {
                      !this.state.showBankId && !this.state.showEmailPw
                        ? <>
                          <div className='login-btns'>
                            {
                              groupObj?.bankIdAuthentication && (groupObj.twoFactorAuthentication || groupObj.mitIdAuthentication) && !hideOtherAuthOptions ?
                                <Button
                                  onClick={() => this.setState({ showBankId: true, showEmailPw: false, createProfile: false })}
                                >
                                  <img src={bankIdIcon} alt='bank id icon' />
                                  {'BankID'.translate(this.props.lang)}
                                </Button>
                                :
                                null
                            }
                            {
                              this.props.country && this.props.country === 'denmark' && groupObj?.mitIdAuthentication && !hideOtherAuthOptions ?
                                <a className='button' href={this.state.showMitId}>
                                  <img src={mitIdIcon} alt='mitId icon' />
                                  {'MitID'.translate(this.props.lang)}
                                </a>
                                :
                                null
                            }
                            {groupObj?.twoFactorAuthentication && (groupObj.bankIdAuthentication || groupObj.mitIdAuthentication) && !hideOtherAuthOptions ? (
                              <div className='auth-divider'>
                                <span>{'or'.translate(this.props.lang)}</span>
                              </div>
                            ) : null}
                            {
                              groupObj?.twoFactorAuthentication /*&& (groupObj.bankIdAuthentication || groupObj.mitIdAuthentication)*/ ?
                                // <Button
                                //   onClick={() => this.setState({ showBankId: false, showEmailPw: true, createProfile: false })}
                                // >
                                //   <img className='invert-img' src={emailAndPasswordIcon} alt='email and pw icon' />
                                //   {'Email and Password'.translate(this.props.lang)}
                                // </Button>
                                <TwoFactorAuthV2LoginComponent
                                  {...this.props}
                                  {...this.state}
                                  onLogin={(data) => { this.login('2fa-v2-login', data) }}
                                  setHideOtherAuthOptions={this.setHideOtherAuthOptions}
                                  alias={this.props?.[0]?.match?.params?.alias}
                                  onBankId={groupObj?.bankIdAuthentication && (groupObj.twoFactorAuthentication || groupObj.mitIdAuthentication) ? () => {
                                    this.setState({ showBankId: true, showEmailPw: false, createProfile: false })
                                  } : undefined}
                                  onMitId={this.props.country && this.props.country === 'denmark' && groupObj?.mitIdAuthentication ? this.state.showMitId : undefined}
                                />
                                :
                                null
                            }
                          </div>
                        </>
                        :
                        null
                    }
                    {/* {
                    this.state.showMitId ?
                      <div className='open-bankid'>
                        <iframe ref={(node) => this.bankIdIframe = node} onLoad={() => {
                          // alert('link' + this.bankIdIframe.contentWindow.location.href)
                          try {
                            if (this.bankIdIframe && this.bankIdIframe.contentWindow && this.bankIdIframe.contentWindow.location && this.bankIdIframe.contentWindow.location.href && this.bankIdIframe.contentWindow.location.href.indexOf('sessionId') !== -1) {
                              this.setState({
                                mitIDRedirect: this.bankIdIframe.contentWindow.location.href,
                                showMitId: null
                              })
                            } else {
                              this.setState({
                                showMitId: null
                              })
                            }
                          } catch (e) { }
                        }} src={this.state.showMitId} style={this.state.mitIDRedirect ? { opacity: 0 } : { width: '100%', height: 770, border: 'none' }} />
                      </div>
                      :
                      null
                  } */}
                    {

                      this.state.showBankId || (groupObj?.bankIdAuthentication && !groupObj?.twoFactorAuthentication && !groupObj?.mitIdAuthentication) ?

                        <>
                          {
                            groupObj && groupObj?.logo && this.props.showGroupLogo ?
                              <img src={API_ENDPOINT + groupObj?.logo} alt='logo' className='bankid-group-logo' />
                              :
                              null

                          }
                          {/* <BankIDModal_v5 {...this.props} alias={this.props?.[0]?.match?.params?.alias} navigateToMyChildren={this.state.navigateToMyChildren} /> */}
                          <BankIDModal_v6 {...this.props} goBack={() => this.setState({
                            showBankId: false,
                            showEmailPw: false,
                            createProfile: false,
                            email: '',
                            password: '',
                            code: '',
                            loginError: null,
                            codeSent: false,
                            uid: null,
                            phone: null
                          })} mode={this.state.mode} updateModeInModal={() => {
                            // console.log('updated mode from child  ');
                            this.setState({ mode: null })
                          }} alias={this.props?.[0]?.match?.params?.alias} navigateToMyChildren={this.state.navigateToMyChildren} />

                        </>
                        :
                        null
                    }
                    {/* {
                    this.state.showEmailPw || (!groupObj?.bankIdAuthentication && !groupObj.mitIdAuthentication && groupObj?.twoFactorAuthentication)
                      ? <div className='email-pw'>
                        {
                          this.state.codeSent
                            ? <>
                              <FormGroup>
                                <div style={{ textAlign: 'center', fontSize: 16, fontWeight: '500', marginBottom: 5 }}>
                                  {this.state.useOnlyEmailFor2fa ? 'Login code sent via email'.translate(this.props.lang) : 'Login code sent via text message'.translate(this.props.lang)}
                                </div>
                                <div style={{ textAlign: 'center', fontSize: 14, marginBottom: 15 }}>{'To'.translate(this.props.lang)}{': '} {this.state.useOnlyEmailFor2fa ? this.state.userEmail : this.state.phone}</div>
                                <Input style={{ width: '90%', margin: 'auto' }} placeholder={'Enter code...'.translate(this.props.lang)} type='text' autoCapitalize='off' autoComplete='off' autoCorrect='off' required value={this.state.code} onChange={e => this.setState({ code: e?.target?.value })} />
                              </FormGroup>
                              {this.state.showCodeMessage ? <div style={{ textAlign: 'center', fontSize: 14 }}>
                                <p style={{ margin: 0, padding: 0, paddingBottom: 10 }}>{'The code is valid for 3 minutes'.translate(this.props.lang)}</p>
                                <p style={{ margin: 0, padding: 0, paddingBottom: 5 }}> {'You can send a new code by clicking here:'.translate(this.props.lang)}</p>
                                <button style={{ outline: 'none', border: 'none', backgroundColor: 'transparent', fontWeight: 'bold', textDecoration: 'underline' }} onClick={() => this.login('resend')}>{'Resend code'.translate(this.props.lang)}</button>
                              </div> : null}
                              {this.state?.loginError ? <div className='error-login-2fa'>
                                <p>{this.state.loginError.translate(this.props.lang)}</p>
                              </div> : null}
                              <Button
                                onClick={() => this.login('code')}
                                className='log-in-button-2fa'
                                style={{ marginTop: 30 }}
                                disabled={!this.state.code?.trim?.() || !isStringAValidNumber(this.state.code) || !this.state?.code?.trim?.().length}
                              >
                                {'Log in'.translate(this.props.lang)}
                              </Button>
                            </>
                            : <>
                              <FormGroup>
                                <Label>{'Email address'.translate(this.props.lang)}</Label>
                                <Input type='email' autoCapitalize='off' autoComplete='off' autoCorrect='off' required value={this.state?.email} onChange={(e) => this.setState({ email: e?.target?.value })} />
                              </FormGroup>
                              <FormGroup>
                                <Label>{'Password'.translate(this.props.lang)}</Label>
                                <Input type='password' autoCapitalize='off' autoComplete='off' autoCorrect='off' required value={this.state?.password} onChange={(e) => this.setState({ password: e?.target?.value })} />
                              </FormGroup>
                              {this.state?.loginError ? <div className='error-login-2fa'>
                                <p>{this.state.loginError.translate(this.props.lang)}</p>
                              </div> : null}
                              <div className='forgot-password-2fa'>
                                <a
                                  href={`/forgotpassword?alias=${this.props[0].match.params.alias}`}
                                  className="forget"
                                >
                                  {"Forgot password?".translate(
                                    this.props.lang
                                  )}
                                </a>
                              </div>

                              <Button
                                onClick={() => this.login('email-pw')}
                                className='log-in-button-2fa'
                                disabled={!this.state?.email?.trim?.() || !isValidEmailAddress(this.state?.email) || !this.state.password?.trim?.() || !isValidPassword(this.state.password)}
                              >
                                {'Log in'.translate(this.props.lang)}
                              </Button>
                              {!this.props.videoCallUserId && !this.props.hideCreateAccountButton && !this.state.codeSent ? <div className='create-account-div'>
                                <button
                                  onClick={() => this.setState({ createProfile: true, showBankId: false }, () => {
                                    if (this.props.checkSSNSwitchCountries) {
                                      this.props.checkSSNSwitchCountries();
                                    }
                                  })}
                                >
                                  {'Create an account'.translate(this.props.lang)}
                                </button>
                              </div> : null}
                            </>
                        }
                      </div>
                      :
                      null
                  } */}
                  </div>
                  :
                  null
                // <BankIDModal_v2 {...this.props} alias={this.props[0].match.params.alias} navigateToMyChildren={this.state.navigateToMyChildren} />
                // <BankIDModal_v5 {...this.props} alias={this.props[0].match.params.alias} navigateToMyChildren={this.state.navigateToMyChildren} />
                :
                this.props.uData && this.state.openFirstPatientLoginModal && typeof window !== 'undefined' && !localStorage?.hidePatientModal ?
                  <FormBuilder
                    selectedGroup={this.props.selectedGroup}
                    selectedClinic={this.props.selectedClinic}
                    country={this.props.country}
                    countryTwoLetter={this.props.countryTwoLetter}
                    dateFormat={this.props.dateFormat}
                    getStringDateTs={this.props.getStringDateTs}
                    lang={this.props.lang}
                    onSubmit={(data) => {
                      if (showPrivacyPolicyCheckbox) {
                        if (!data.privacyPolicy) {
                          data.privacyPolicy = {}
                        }
                        if (groupObj && groupObj._id)
                          data.privacyPolicy[groupObj._id] = true;
                      }
                      this.update(data)
                    }}
                    initialValues={this.props.uData}
                    invalidMessage={"Please fill in required fields".translate(this.props.lang)}
                    toggle={() => this.setState({ form: null })}
                    buttonText={showPrivacyPolicyCheckbox ? 'Agree to Terms of Service and continue'.translate(this.props.lang) : 'Save'.translate(this.props.lang)}
                    buttonsWrapClassName={'empty'}
                    afterTextComponent={label2}

                    additionalButton={<Button style={{ marginLeft: 10 }} color="danger" onClick={() => this.props.signOut()}>{'Logout'.translate(this.props.lang)}</Button>}
                    fields={[
                      {
                        type: 'row',
                        children: [
                          {
                            type: 'col',
                            width: {
                              lg: 12,
                              sm: 12,
                              xs: 12
                            },
                            children: [
                              {
                                type: 'socialSecurityNumber',
                                disabled: true,
                                name: 'socialSecurityNumber',
                                label: this.props.country === 'uk' ? "Date of birth".translate(this.props.lang) : 'Social security number'.translate(this.props.lang),
                                validate: [required('Social security number is required!'.translate(this.props.lang))]

                              },
                            ]
                          },

                          /*{
                              type: 'col',
                              width: {
                                  lg: 3,
                                  sm: 12,
                                  xs: 12
                              },
                              children: [
                                  {
                                      type: 'text',
                                      name: 'userData.title',
                                      label: 'Title'.translate(this.props.lang),
                                      disabled: this.props.alias
                                  },
                              ]
                          },*/
                          {
                            type: 'col',
                            width: {
                              lg: 12,
                              sm: 12,
                              xs: 12
                            },
                            children: [
                              {
                                type: 'text',
                                name: 'userData.name',
                                label: 'First and last name'.translate(this.props.lang),
                                // disabled: this.props.alias,
                                disabled: this.props.uData && this.props.uData.userData && this.props.uData.userData.name ? true : false,
                                validate: [required('First and last name is required!'.translate(this.props.lang))]

                              },
                            ]
                          },
                          {
                            type: 'col',
                            width: {
                              lg: 12,
                              sm: 12,
                              xs: 12
                            },
                            children: [
                              {
                                type: 'gender',
                                name: 'userData.sex',
                                labelInfo: "Your biological sex is needed for proper treatment".translate(this.props.lang),
                                // label: 'Sex'.translate(this.props.lang),
                                // values: [{ value: 0, name: 'Select'.translate(this.props.lang) }, { value: 'male', name: 'Male'.translate(this.props.lang) }, { value: 'female', name: 'Female'.translate(this.props.lang) }],
                                // validate: [required('Sex is required!'.translate(this.props.lang))],
                                groupData: groupObj,
                                validate: [validateGender(groupObj?.patientInfoSettings?.canHaveOtherGender === true, this.props.lang)]
                              },
                            ]
                          },
                          this.props.showDateOfBirth ?
                            {
                              type: 'col',
                              width: {
                                lg: 12,
                                sm: 12,
                                xs: 12
                              },
                              children: [
                                {
                                  type: 'date-of-birth',
                                  dateFormat: this.props.dateFormat,
                                  name: 'dateOfBirth.date',
                                  disabled: this.state.disabledDateOfBirth,
                                  label: 'Date of birth'.translate(this.props.lang),
                                  validate: [required('Date of birth is required!'.translate(this.props.lang)), dateValidate('Invalid date!'.translate(this.props.lang))]

                                },
                              ]
                            } : null,
                          {
                            type: 'col',
                            width: {
                              lg: 12,
                              sm: 12,
                              xs: 12
                            },
                            children: [
                              {
                                type: 'email',
                                name: 'email',
                                label: 'Email address'.translate(this.props.lang),
                                validate: [required('Email address is required!'.translate(this.props.lang)), emailAddress('Invalid email address!'.translate(this.props.lang))]
                              },
                            ]
                          },
                          {
                            type: 'col',
                            width: {
                              lg: 12,
                              sm: 12,
                              xs: 12
                            },
                            children: [
                              {
                                type: 'phone',
                                name: 'phone',
                                label: 'Phone number'.translate(this.props.lang),
                                validate: [required('Phone number is required!'.translate(this.props.lang))]
                              },
                            ]
                          },
                          {
                            type: 'col',
                            width: {
                              lg: 12,
                              sm: 12,
                              xs: 12
                            },
                            children: [
                              {
                                type: 'text',
                                name: 'street',
                                label: 'Street'.translate(this.props.lang),
                                validate: [required('Street is required!'.translate(this.props.lang))]
                              },
                            ]
                          },
                          {
                            type: 'col',
                            width: {
                              lg: 3,
                              sm: 12,
                              xs: 12
                            },
                            children: [
                              {
                                type: 'text',
                                name: 'zip',
                                // pattern: new RegExp(/[0-9 ]+/i),
                                label: 'Postal code'.translate(this.props.lang),
                                validate: [required('Postal code is required!'.translate(this.props.lang))]
                              },
                            ]
                          },
                          {
                            type: 'col',
                            width: {
                              lg: 9,
                              sm: 12,
                              xs: 12
                            },
                            children: [
                              {
                                type: 'text',
                                name: 'city',
                                // pattern: new RegExp(/^[a-zA-Z \u00c0-\u017e]$/i),
                                pattern: new RegExp(/^[a-zA-Z \u00c0-\u017e\u0370-\u03FF ]$/i),
                                label: 'City'.translate(this.props.lang),
                                validate: [required('City is required!'.translate(this.props.lang))]
                              },
                            ]
                          },
                          {
                            type: "col",
                            width: {
                              lg: 12,
                              sm: 12,
                              xs: 12,
                            },
                            style: { padding: 0, marginTop: 15 },
                            children: [
                              {
                                type: "col",
                                width: {
                                  lg: 12,
                                  sm: 12,
                                  xs: 12,
                                },
                                children: [
                                  {
                                    type: "h6",
                                    text: 'Related parties'.translate(this.props.lang)
                                  },
                                ],
                              },
                              {
                                type: "col",
                                width: {
                                  lg: 12,
                                  sm: 12,
                                  xs: 12,
                                },

                                children: [
                                  {
                                    type: "hr",
                                  },
                                ],
                              },
                            ],
                          },

                          {
                            type: "col",
                            width: {
                              lg: 6,
                              sm: 12,
                              xs: 12,
                            },
                            children: [
                              {
                                type: "text",
                                name: "userData.relatedParties.name",
                                label: "Name".translate(
                                  this.props.lang
                                ),
                              },
                            ],
                          },
                          {
                            type: "col",
                            width: {
                              lg: 6,
                              sm: 12,
                              xs: 12,
                            },
                            children: [
                              {
                                type: "text",
                                name: "userData.relatedParties.relations",
                                label: "Relations".translate(
                                  this.props.lang
                                ),
                              },
                            ],
                          },

                          {
                            type: "col",
                            width: {
                              lg: 6,
                              sm: 12,
                              xs: 12,
                            },
                            style: { padding: 0 },
                            children: [
                              {
                                type: "col",
                                width: {
                                  lg: 12,
                                  sm: 12,
                                  xs: 12,
                                },
                                children: [
                                  {
                                    type: "phone",
                                    name: "userData.relatedParties.phone",
                                    label: "Phone 1".translate(
                                      this.props.lang
                                    ),
                                  },
                                ],
                              },
                              {
                                type: "col",
                                width: {
                                  lg: 12,
                                  sm: 12,
                                  xs: 12,
                                },

                                children: [
                                  {
                                    type: "phone",
                                    name: "userData.relatedParties.phone2",
                                    label: "Phone 2".translate(
                                      this.props.lang
                                    ),
                                  },
                                ],
                              },
                            ],
                          },


                          {
                            type: "col",
                            width: {
                              lg: 6,
                              sm: 12,
                              xs: 12,
                            },
                            children: [
                              {
                                type: "textarea",
                                name: "userData.otherInformations",
                                height: 152,
                                label: "Other information".translate(
                                  this.props.lang
                                ),
                              },
                            ],
                          },
                          showPrivacyPolicyCheckbox ?
                            {
                              type: "col",
                              width: {
                                lg: 12,
                                sm: 12,
                                xs: 12,
                              },
                              children: [
                                {
                                  type: "privacy-policy-checkbox",
                                  name: `privacyPolicy.${groupObj._id}`,
                                  groupData: groupObj,
                                  lang: this.props.lang,
                                  // validate: [required('Privacy Policy is required!'.translate(this.props.lang))]
                                },
                              ],
                            }
                            :
                            {
                              type: 'empty'
                            },
                          // {
                          //     type: 'col',
                          //     width: {
                          //         lg: 6,
                          //         sm: 12,
                          //         xs: 12
                          //     },
                          //     children: [
                          //         {
                          //             type: 'checkbox',
                          //             name: 'notifications.email',
                          //             afterText: 'E-mail notification'.translate(this.props.lang),
                          //         },
                          //         {
                          //             type: 'checkbox',
                          //             name: 'notifications.sms',
                          //             afterText: 'SMS notification'.translate(this.props.lang),
                          //         },

                          //     ]
                          // },




                        ]
                      }
                    ]}
                  ></FormBuilder>
                  :
                  null

            }
            <p className="error-message">{this.state.error}</p>


          </div>
          {this.props.sideComponent ? <div>
            {this.props.sideComponent}
          </div> : null}
        </ModalBody>
      </Modal>
    )
  }
}

const selector2 = formValueSelector("form");


export default connect(
  (state) => {
    return {
      sex: selector2(state, 'userData.sex'),
      socialSecurityNumber: selector2(state, 'socialSecurityNumber'),
      dateOfBirth: selector2(state, 'dateOfBirth.date'),
    };
  },
  {
    changeSex: (value) => change("form", "userData.sex", value),
    changeDateOfBirth: value => change("form", "dateOfBirth.date", value)

  }
)(BankIdModal);
